import Container from "@components/Container/Container";
import { useWindowSize } from "@hooks/useWindowSize";

import DTAFooterDesktop from "./DTAFooterDesktop";
import DTAFooterMobile from "./DTAFooterMobile";

/**
 * Component to display footer in DTA pages
 */
const DTAFooter = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <footer
      data-testid="dta-footer-component"
      className="mb-4 bg-gray-850 pb-7 pt-10 font-public-sans"
    >
      <Container rootClassName="flex flex-row justify-center text-white">
        {isScreenLG ? <DTAFooterDesktop /> : <DTAFooterMobile />}
      </Container>
    </footer>
  );
};

export default DTAFooter;
